import React from 'react';
import ReactModal from 'react-modal'; // http://reactcommunity.org/react-modal
import style from './modal.module.scss';

const Modal = ({ isOpen, content, onClose }) => {
	return (
		<ReactModal
			style={modalStyle}
			isOpen={isOpen}
			shouldCloseOnOverlayClick
			shouldCloseOnEsc
			ariaHideApp={false}
			onRequestClose={onClose}
		>
			<div className={style.closeButton} onClick={onClose}>x</div>
			{content}
		</ReactModal>
	);
};

const modalStyle = {
	overlay: {},
	content: {
		maxWidth: 500,
		maxHeight: 500,
		width: 'auto',
		height: 'auto',
		top: 0,
		bottom: 0,
		right: 10,
		left: 10,
		margin: 'auto',
	}
};

export default Modal;
